import { videoPlayed, videoPaused, videoEnded } from "../src/segment-tracks.js";
import { win } from "./lib/pd-window.js";

win._wq = win._wq || [];

win._wq.push({
  id: "_all",
  onReady: function (
    /** @type {{ data: { media: { hashedId: any; duration: number; name: any; }; }; bind: (arg0: string, arg1: { (): void; (): void; (): void; }) => void; time: () => number; }} */ video,
  ) {
    let options = {
      video_id: video.data.media.hashedId,
      video_duration: Math.round(video.data.media.duration),
      video_current_time: Math.round(video.time()) || 0,
      video_percent:
        Math.round((video.time() / video.data.media.duration) * 100) || 0,
      video_provider: "wistia",
      video_title: video.data.media.name || "NA",
      video_url: "NA",
    };

    video.bind("play", function () {
      options.video_current_time = Math.round(video.time()) || 0;
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoPlayed(options);
    });

    video.bind("pause", function () {
      options.video_current_time = Math.round(video.time()) || 0;
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoPaused(options);
    });

    video.bind("end", function () {
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoEnded(options);
    });
  },
});
